import {createRouter, createWebHistory, RouterView} from "vue-router";

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: "/",
            name: "home",
            component: () => import("@/views/clients/ClientsListing.vue"),
        },
        {
            path: "/maintenance",
            name: "maintenance",
            component: () => import("@/components/layout/UnderMaintenance.vue"),
        },
        {
            path: "/dashboard-editor/:pageId",
            name: "chart-dashboard-editor",
            component: () => import("@/views/chart_builder/ChartDashboardEditor.vue"),
        },
        {
            path: "/chat",
            name: "oneclick-chat",
            component: () => import("@/views/ai/OneClickChat.vue"),
        },
        {
            path: "/mcp-tokens",
            name: "mcp-tokens",
            component: () => import("@/views/access_tokens/McpTokens.vue"),
        },
        {
            path: "/mcp-token-activities",
            name: "mcp-token-activities",
            component: () => import("@/views/access_tokens/McpTokenActivities.vue"),
        },
        {
            path: "/client-mcp-tokens",
            name: "client-mcp-tokens",
            component: () => import("@/views/access_tokens/ClientMcpTokens.vue"),
        },
        {
            path: "/client-mcp-token-activities",
            name: "client-mcp-token-activities",
            component: () => import("@/views/access_tokens/ClientMcpTokenActivities.vue"),
        },
        {
            path: "/clients",
            component: () => import("@/sections/Clients.vue"),
            children: [
                {
                    path: "clients-listing",
                    name: "clients-listing",
                    component: () => import("@/views/clients/ClientsListing.vue"),
                },
                {
                    path: "account-receivables",
                    name: "account-receivables",
                    component: () => import("@/views/clients/AccountReceivables.vue"),
                },
                {
                    path: "create/:business_line",
                    name: "create-prospect",
                    component: () => import("@/views/clients/CreateManageProspect.vue"),
                },
                {
                    path: "manage-prospect/:id/:business_line",
                    name: "manage-prospect",
                    component: () => import("@/views/clients/CreateManageProspect.vue"),
                },
                {
                    path: "roles-permissions",
                    name: "client-roles-permissions",
                    component: () => import("@/views/clients/ClientRolesPermissions.vue"),
                },
                {
                    path: "contact/:id",
                    name: "contact",
                    component: () => import("@/views/clients/ContactInformation.vue"),
                },
                {
                    path: "create-contact",
                    name: "create-contact",
                    component: () => import("@/views/clients/CreateContact.vue"),
                },
                {
                    path: "create-contact/company/:company_id",
                    name: "create-contact-company",
                    component: () => import("@/views/clients/CreateContact.vue"),
                },
                {
                    path: "edit-contact/:id",
                    name: "edit-contact",
                    component: () => import("@/views/clients/CreateContact.vue"),
                },
                {
                    path: "contacts",
                    name: "contacts",
                    component: () => import("@/views/clients/ContactsListing.vue"),
                },
                {
                    path: "company/:id",
                    name: "company",
                    component: () => import("@/views/clients/CompanyInformation.vue"),
                },
                {
                    path: "manage-client-user/:id",
                    name: "manage-client-user",
                    component: () => import("@/views/clients/ManageUserClient.vue"),
                },
                {
                    path: "company-users",
                    name: "company-users",
                    component: () => import("@/views/clients/CompanyUsers.vue"),
                },
                {
                    path: "company-user-activity/:client_user_id?",
                    name: "company-user-activity",
                    component: () => import("@/views/clients/CompanyUserActivity.vue"),
                },
                {
                    path: "all-companies",
                    name: "all-companies",
                    component: () => import("@/views/clients/CompaniesForAll.vue"),
                },

            ]
        },
        {
            path: "/klg-users",
            component: () => import('@/sections/KlgUsers.vue'),
            children: [
                {
                    path: "",
                    name: "klg-users-listing",
                    component: () => import("@/views/klg_users/KlgUsersListing.vue"),
                },
                {
                    path: "roles-permissions",
                    name: "klg-roles-permissions",
                    component: () => import("@/views/klg_users/KlgRolesPermissions.vue"),
                },
                {
                    path: "manage-user/:id",
                    name: "klg-manage-user",
                    component: () => import("@/views/klg_users/KlgManageUser.vue"),
                },
                {
                    path: "user-activity/:user_id?",
                    name: "user-activity",
                    component: () => import("@/views/klg_users/UserActivity.vue"),
                },
                {
                    path: "login-as",
                    name: "klg-roles-permissions-login-as",
                    component: () => import("@/views/klg_users/LoginAsRolesPermissions.vue"),
                },
            ]
        },
        {
            path: "/site-admin",
            component: () => import('@/sections/SiteAdmin.vue'),
            children: [
                {
                    path: "bussiness-lines",
                    name: "bussiness-lines-listing",
                    component: () => import("@/views/site_admin/BussinessLinesListing.vue"),
                },
                {
                    path: "branches",
                    name: "branches-listing",
                    component: () => import("@/views/site_admin/BranchesListing.vue"),
                },
                {
                    path: "/client-permission-and-pages",
                    name: "client-permission-and-pages",
                    component: () => import("@/views/site_admin/Permissions/ClientPermissionPages.vue"),
                },
                {
                    path: "/klg-permission-and-pages",
                    name: "klg-permission-and-pages",
                    component: () => import("@/views/site_admin/Permissions/KlgPermissionPages.vue"),
                },
                {
                    path: "/klg-permissions-import",
                    name: "klg-permissions-import",
                    component: () => import("@/views/site_admin/Permissions/KlgPermissionsImport.vue"),
                },
                {
                    path: "resources",
                    name: "resources-listing",
                    component: () => import("@/views/site_admin/Permissions/Resources.vue"),
                },
                {
                    path: "resources/create-field/:json_resource_id",
                    name: "resources-fields-listing",
                    component: () => import("@/views/site_admin/Permissions/ResourceFieldsListing.vue"),
                },
                {
                    path: "forms",
                    name: "forms-listing",
                    component: () => import("@/views/site_admin/Permissions/FormsListing.vue"),
                },
                {
                    path: "forms/create-field/:form_id",
                    name: "forms-fields-listing",
                    component: () => import("@/views/site_admin/Permissions/FormFieldsListing.vue"),
                },
                {
                    path: "option-categories",
                    name: "option-categories-listing",
                    component: () => import("@/views/site_admin/OptionValues/OptionCategoriesListing.vue"),
                },
                {
                    path: "option-category-values/:option_category_id",
                    name: "option-category-values-listing",
                    component: () => import("@/views/site_admin/OptionValues/OptionCategoryValuesListing.vue"),
                },
                {
                    path: "maintenances",
                    name: "maintenances",
                    component: () => import("@/views/site_admin/Maintenances.vue"),
                },
                {
                    path: "pages",
                    name: "pages",
                    component: () => import("@/views/site_admin/Pages.vue"),
                },
                {
                    path: "page-fields/:page_id",
                    name: "page-fields-listing",
                    component: () => import("@/views/site_admin/PageFields.vue"),
                },

            ]
        },
        {
            path: "/site-config",
            component: () => import('@/sections/SiteConfig.vue'),
            children: [
                {
                    path: "api-sources",
                    name: "api-sources",
                    component: () => import('@/views/site_config/ApiSources.vue')
                },
                {
                    path: "app-statuses",
                    name: "app-statuses",
                    component: () => import('@/views/site_config/AppStatuses.vue')
                },
                {
                    path: "api-statuses",
                    name: "api-statuses",
                    component: () => import('@/views/site_config/ApiStatuses.vue')
                },
                {
                    path: "authorized-emails",
                    name: "authorized-emails",
                    component: () => import('@/views/site_config/AuthorizeEmails.vue')
                },
                {
                    path: "/email_auth/callback",
                    name: "authorized-emails-callback",
                    component: () => import('@/views/site_config/AuthorizedEmailsCallback.vue')
                },
                {
                    path: "etransport-declarations",
                    name: "etransport-declarations",
                    component: () => import('@/views/etransport/EtransportDeclarations.vue')
                },
                {
                    path: "etransport-declaration/:id?",
                    name: "etransport-declaration",
                    component: () => import('@/views/etransport/EtransportDeclaration.vue')
                },
                {
                    path: "tooltip-categories",
                    name: "tooltip-categories",
                    component: () => import('@/views/site_config/TooltipCategories.vue')
                },
                {
                    path: "tooltip-values/:tooltip_category_id",
                    name: "tooltip-values",
                    component: () => import('@/views/site_config/TooltipValues.vue')
                },
                {
                    path: "departments",
                    name: "departments",
                    component: () => import('@/views/site_config/Departments.vue')
                },
                {
                    path: "notifications",
                    name: "notifications",
                    component: () => import('@/views/site_config/Notifications.vue')
                },
                {
                    path: "alerts",
                    name: "alerts",
                    component: () => import('@/views/alerts/Alerts.vue')
                },
                {
                    path: "currencies",
                    name: "currencies",
                    component: () => import('@/views/site_config/Currencies.vue')
                },
                {
                    path: "sales-persons",
                    name: "sales-persons",
                    component: () => import('@/views/site_config/SalePersonPurchaser.vue')
                },
                {
                    path: "key-account-managers",
                    name: "key-account-managers",
                    component: () => import('@/views/site_config/KeyAccountManagers.vue')
                },
                {
                    path: "payment-terms",
                    name: "payment-terms",
                    component: () => import('@/views/site_config/PaymentTerms.vue')
                },
                {
                    path: "invoice-lines",
                    name: "invoice-lines",
                    component: () => import('@/views/site_config/InvoiceLines.vue')
                },
                {
                    path: "emails",
                    name: "emails",
                    component: () => import("@/views/site_config/Emails.vue"),
                },
                {
                    path: "company-emails",
                    name: "company-emails",
                    component: () => import("@/views/site_config/CompanyEmails.vue"),
                },
                {
                    path: "webmail-domains",
                    name: "webmail-domains",
                    component: () => import("@/views/site_config/WebmailDomains.vue"),
                },
                {
                    path: "allowed-register-domains",
                    name: "allowed-register-domains",
                    component: () => import("@/views/site_config/AllowedRegisterDomain.vue"),
                },
                {
                    path: "exchange-rates",
                    name: "exchange-rates",
                    component: () => import("@/views/site_config/ExchangeRates.vue"),
                },
                {
                    path: "contract-managers",
                    name: "contract-managers",
                    component: () => import('@/views/site_config/ContractManagers.vue')
                },
                {
                    path: "indoor-sales",
                    name: "indoor-sales",
                    component: () => import('@/views/site_config/IndoorSales.vue')
                },
                {
                    path: "site-notifications",
                    name: "site-notifications",
                    component: () => import("@/views/site_config/SiteNotifications.vue"),
                },
                {
                    path: "releases",
                    name: "releases",
                    component: () => import("@/views/site_config/Releases.vue"),
                },
                {
                    path: "ai-agents",
                    name: "ai-agents",
                    component: () => import("@/views/site_config/AI/AiAgents.vue"),
                },
            ]
        },
        {
            path: "/transport-site-config",
            component: () => import('@/sections/TransportSiteConfig.vue'),
            children: [
                {
                    path: "activity-statuses",
                    name: "activity-statuses",
                    component: () => import('@/views/transport_site_config/ActivityStatuses.vue')
                }, {
                    path: "activity-types",
                    name: "activity-types",
                    component: () => import('@/views/transport_site_config/ActivityTypes.vue')
                },
                {
                    path: "legal-holidays",
                    name: "legal-holidays",
                    component: () => import('@/views/transport_site_config/LegalHolidays.vue')
                },
            ]
        },
        {
            path: "/warehousing-site-config",
            component: () => import('@/sections/WarehousingSiteConfig.vue'),
            children: [
                {
                    path: "shippers",
                    name: "shippers",
                    component: () => import('@/views/warehousing_site_config/Shippers.vue')
                },
            ]
        },
        {
            path: "/access-tokens",
            component: () => import('@/sections/Krakend.vue'),
            children: [
                {
                    path: "krakend-endpoints",
                    name: "krakend-endpoints",
                    component: () => import("@/views/access_tokens/KrakendEndpoints.vue"),
                },
                {
                    path: "krakend-tokens",
                    name: "krakend-tokens",
                    component: () => import("@/views/access_tokens/KrakendTokens.vue"),
                },
                {
                    path: "krakend-token-demands",
                    name: "krakend-token-demands",
                    component: () => import("@/views/access_tokens/KrakendTokenDemands.vue"),
                },
                {
                    path: "oneclick-tokens",
                    name: "oneclick-tokens",
                    component: () => import("@/views/access_tokens/OneclickTokens.vue"),
                },
                {
                    path: "oneclick-token-demands",
                    name: "oneclick-token-demands",
                    component: () => import("@/views/access_tokens/OneclickTokenDemands.vue"),
                },
                {
                    path: "applications",
                    name: "applications",
                    component: () => import("@/views/access_tokens/RegisteredApplications.vue"),
                },
                {
                    path: "application-demands",
                    name: "application-demands",
                    component: () => import("@/views/access_tokens/ApplicationDemands.vue"),
                },
            ]
        },
        {
            path: "/ai",
            component: () => import('@/sections/AI.vue'),
            children: [
                {
                    path: "ai-dashboard",
                    name: "ai-dashboard",
                    component: () => import("@/views/ai/DashboardAI.vue"),
                },
                {
                    path: "ai-dashboard/:agent_id",
                    name: "ai-dashboard-agent",
                    component: () => import("@/views/ai/OneClickChat.vue"),
                },
                {
                    path: "cleo-documents",
                    name: "cleo-documents",
                    component: () => import("@/views/ai/CleoDocuments.vue"),
                },
                {
                    path: "cleo-history",
                    name: "cleo-history",
                    component: () => import("@/views/ai/components/Cleo/CleoConversationHistory.vue"),
                },
                {
                    path: "client-cleo-history",
                    name: "client-cleo-history",
                    component: () => import("@/views/ai/components/Cleo/ClientCleoConversationHistory.vue"),
                },
                {
                    path: "cleo-insights",
                    name: "cleo-insights",
                    component: () => import("@/views/ai/CleoInsights.vue"),
                },
                {
                    path: "cleo-limits",
                    name: "cleo-limits",
                    component: () => import("@/views/ai/CleoLimits.vue"),
                },
            ]
        },
        {
            path: "/oneclick-documentation",
            name: "oneclick-documentation",
            component: () => import("@/views/oneclick_documentation/OneClickDocumentation.vue"),
        },
        {
            path: "/admin-documentation",
            name: "admin-documentation",
            component: () => import("@/views/oneclick_documentation/AdminDocumentation.vue"),
        },
        {
            path: "/client-documentation",
            name: "client-documentation",
            component: () => import("@/views/client_documentation/ClientDocumentation.vue"),
        },
        {
            path: "/order-entry",
            component: () => import('@/sections/OrderEntrySettings.vue'),
            children: [
                {
                    path: "general-settings",
                    name: "general-settings",
                    component: () => import("@/views/order_entry/GeneralSettings.vue"),
                },
                {
                    path: "incoterms",
                    name: "incoterms",
                    component: () => import("@/views/order_entry/Incoterms.vue"),
                },
                {
                    path: "packages",
                    name: "packages",
                    component: () => import("@/views/order_entry/Packages.vue"),
                },
                {
                    path: "features",
                    name: "features",
                    component: () => import("@/views/order_entry/Features.vue"),
                },
            ]
        },
        {
            path: "/erp",
            component: () => import('@/sections/Erp.vue'),
            children: [
                {
                    path: "vendors",
                    name: "vendors",
                    component: () => import("@/views/erp/Vendors.vue"),
                },
                {
                    path: "customers",
                    name: "customers",
                    component: () => import("@/views/erp/Customers.vue"),
                },
                {
                    path: "vendor-invoice-details/:entry_no",
                    name: "vendor-invoice-details",
                    component: () => import("@/views/erp/VendorInvoiceDetails.vue"),
                },
                {
                    path: "customer-invoice-details/:entry_no",
                    name: "customer-invoice-details",
                    component: () => import("@/views/erp/CustomerInvoiceDetails.vue"),
                },
            ]
        },
        {
            path: "/api-docs",
            component: () => import('@/sections/ApiDocs.vue'),
            children: [
                {
                    path: "api-resources",
                    name: "api-resources-listing",
                    component: () => import("@/views/documentation/ApiResources.vue"),
                },
                {
                    path: "oneclick-fields",
                    name: "api-resources-fields-listing",
                    component: () => import("@/views/documentation/ApiResourceFieldsListing.vue"),
                },
                // {
                //     path: "api-resources/routes/:api_resource_id",
                //     name: "api-resources-routes-listing",
                //     component: () => import("@/views/documentation/ApiResourceRoutesListing.vue"),
                // },
                {
                    path: "api-route-fields",
                    name: "api-route-fields",
                    component: () => import("@/views/documentation/ApiRouteFieldsListing.vue"),
                },
                {
                    path: "api-route-groups",
                    name: "api-route-groups",
                    component: () => import("@/views/documentation/ApiRouteGroup.vue"),
                },
                {
                    path: "api-releases",
                    name: "api-releases",
                    component: () => import("@/views/documentation/ApiReleases.vue"),
                },
                {
                    path: "application-api-resources",
                    name: "application-api-resources-listing",
                    component: () => import("@/views/documentation/ApplicationApiResources.vue"),
                },
                {
                    path: "application-api-resource-fields",
                    name: "application-api-resource-fields-listing",
                    component: () => import("@/views/documentation/ApplicationApiResourceFieldsListing.vue"),
                },
                {
                    path: "application-api-route-fields",
                    name: "application-api-route-fields",
                    component: () => import("@/views/documentation/ApplicationApiRouteFieldsListing.vue"),
                },
                {
                    path: "application-api-route-groups",
                    name: "application-api-route-groups",
                    component: () => import("@/views/documentation/ApplicationApiRouteGroup.vue"),
                },
                {
                    path: "application-api-documentation",
                    name: "application-api-documentation",
                    component: () => import("@/views/documentation/ApplicationApiDocumentation.vue"),
                },
            ]
        },

        {
            path: "/news",
            name: "news",
            component: () => import("@/views/klg_users/News.vue"),
        },
        {
            path: "/client-news",
            name: "client-news",
            component: () => import("@/views/clients/ClientNews.vue"),
        },
        {
            path: "/self-service-news",
            name: "self-service-news",
            component: () => import("@/views/documentation/SelfServiceNews.vue"),
        },
        // {
        //     path: "/ai/Z0LEiz6JGD",
        //     name: "ai",
        //     component: () => import("@/views/AI.vue"),
        // },
        {
            path: "/login",
            name: "login",
            meta: {
                layout: "LayoutGuest"
            },
            component: () => import("@/views/auth/Login.vue"),
        },
        {
            path: "/login-error",
            name: "login-error",
            meta: {
                layout: "LayoutGuest"
            },
            component: () => import("@/views/auth/LoginError.vue"),
        },
        {
          path: "/voucher-issue",
          name: "voucher-issue",
          meta: {
            layout: "LayoutGuest"
          },
          component: () => import("@/views/auth/VoucherIssue.vue"),
        },
        {
          path: "/session-expired",
          name: "session-expired",
          meta: {
            layout: "LayoutGuest"
          },
          component: () => import("@/views/auth/SessionExpiredIssue.vue"),
        },
        {
          path: "/unsubscribe",
          name: "unsubscribe",
          meta: {
            layout: "LayoutGuest"
          },
          component: () => import("@/views/notifications/Unsubscribe.vue"),
        },
        {
            path: "/login-error-role",
            name: "login-error-role",
            meta: {
                layout: "LayoutGuest"
            },
            component: () => import("@/views/auth/LoginErrorRole.vue"),
        },
        {
            path: "/login-error-block",
            name: "login-error-block",
            meta: {
                layout: "LayoutGuest"
            },
            component: () => import("@/views/auth/LoginErrorBlock.vue"),
        },
        {
            path: "/login-error-account",
            name: "login-error-account",
            meta: {
                layout: "LayoutGuest"
            },
            component: () => import("@/views/auth/LoginErrorAccount.vue"),
        },
        {
            path: "/auth/callback",
            name: "callback",
            meta: {
                layout: "LayoutGuest"
            },
            component: () => import("@/views/auth/Callback.vue"),
        },
        {
            path: "/my-profile/:id",
            name: "my-profile",
            component: () => import("@/views/klg_users/MyProfile.vue"),
        },
        {
            path: "/activity-log",
            name: "activity-log",
            component: () => import('@/views/klg_users/ActivityLog.vue')
        },
        {
            path: "/inbounds/:status_selected?",
            name: "inbounds",
            component: () => import('@/views/shipments/Inbounds.vue')
        },
        {
            path: "/outbounds/:status_selected?",
            name: "outbounds",
            component: () => import('@/views/shipments/Outbounds.vue')
        },
        {
            path: "/domestic-shipments/:status_selected?",
            name: "domestic-shipments",
            component: () => import('@/views/shipments/Road/DomesticRoad.vue')
        },
        {
            path: "/international-shipments/:status_selected?",
            name: "international-shipments",
            component: () => import('@/views/shipments/Road/InternationalRoad.vue')
        },
        {
            path: "/ocean/:status_selected?",
            name: "ocean",
            component: () => import('@/views/shipments/Ocean.vue')
        },
        {
            path: "/air/:status_selected?",
            name: "air",
            component: () => import('@/views/shipments/Air.vue')
        },
        {
            path: "/strongo-shipments/:status_selected?",
            name: "strongo-shipments",
            component: () => import('@/views/shipments/Strongo/Strongo.vue')
        },
        {
            path: "/strongo-shipment-overview/:shipment_id",
            name: "strongo-shipment-overview",
            component: () => import("@/views/shipments/Strongo/ShipmentOverviewStrongo.vue"),
        },
        {
            path: "/vbs-inbounds",
            name: "vbs-inbounds",
            component: () => import('@/views/shipments/VbsReportInbounds.vue')
        },
        {
            path: "/vbs-outbounds",
            name: "vbs-outbounds",
            component: () => import('@/views/shipments/VbsReportOutbounds.vue')
        },
        {
            path: "/download-file/:file_type/:resource_id",
            name: "download-pod",
            component: () => import('@/views/DownloadFile.vue')
        },
        {
            path: "/shipment-overview/:transport_type/:shipment_id",
            name: "shipment-overview",
            component: () => import("@/views/shipments/Road/ShipmentOverviewRoad.vue"),
        },
    ],
    scrollBehavior(to, from, savedPosition) {
        if (from && Object.keys(to.query).length) {
            if (to.fullPath.split('?')[0] == from.fullPath.split('?')[0]) return;
        }
        if (to.hash) {
            return {
                el: to.hash,
                behavior: 'smooth',
            };
        } else if (savedPosition) {
            return savedPosition
        } else {
            return {top: 0}
        }
    },
});

export default router;
